const inputStyles = (theme) => ({
  input: {
    "&:-webkit-autofill": {
      WebkitBoxShadow:
        theme.palette.type === "dark" ? "0 0 0 100px #292828 inset" : null,
      WebkitTextFillColor: theme.palette.type === "dark" ? "#fff" : null,
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
    },
  },
});

export default inputStyles;
